import React from "react";

import { Loader2 } from "lucide-react";

import { Button } from "~/components/ui/button";
import { useProfileStore } from "~/store/profileStore";
import { formatCurrency } from "~/utils/helpers";

interface OrderFooterProps {
  total: number;
  isFormValid: boolean;
  isSubmitting?: boolean;
  onSave: () => void;
  availableCredit?: number;
}

const OrderFooter: React.FC<OrderFooterProps> = ({
  total,
  isFormValid,
  isSubmitting = false,
  onSave,
  availableCredit,
}) => {
  const { role } = useProfileStore();
  const isSeller = role === "seller";

  return (
    <div className="flex items-center justify-between p-4">
      <div>
        <p className="text-sm text-gray-500">Total</p>
        <p className="text-xl font-semibold">{formatCurrency(total)}</p>
        {!isSeller && availableCredit !== undefined && (
          <p className="mt-1 text-xs text-gray-400">
            Para aprobación instantánea, debe ser bajo el monto:{" "}
            {formatCurrency(availableCredit)}
          </p>
        )}
      </div>
      <Button
        disabled={!isFormValid || isSubmitting}
        onClick={onSave}
        className="px-6"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Guardando...
          </>
        ) : (
          "Guardar Orden"
        )}
      </Button>
    </div>
  );
};

export default OrderFooter;
